import {useStore} from "@nanostores/react";
import {type FC} from "react";
import {SessionAtom, signOut} from "../store/session.mjs";
import {Relays} from "./pages/Relays";

const Application: FC = () => {
    const session = useStore(SessionAtom);

    return (
        <>
            <header className="bar">
                <hgroup>
                    <h2>{"Egressor"}</h2>
                    <p>{"Исходящие запросы через выбранный регион"}</p>
                </hgroup>
                <div className="right">
                    <small>{session?.title}</small>
                    <br />
                    <a href="#" onClick={() => void signOut()}>
                        {"Выйти"}
                    </a>
                </div>
            </header>

            <Relays />
        </>
    );
};

export default Application;
